import { object, ObjectSchema, string } from 'yup'

export const urlRefreshValidationSchema: ObjectSchema = object({
  url: string()
    .matches(
      /^(https?:\/\/|www\.)\S+$/, // Match website url
      'Please enter valid URL'
    )
    .required('URL is required'),
})
